<template v-if="chartData">
  <div :id="`${chartData.name}ChartWrapper`" class="chart__wrapper">
    <h6 class="chart__title">{{ chartData.title }}</h6>
    <span class="chart__subtitle">{{ chartData.subtitle }}</span>
    <div class="chart__canvas_wrapper">
      <canvas :id="chartData.name"></canvas>
    </div>
  </div>
</template>

<script>
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Tooltip,
  Legend,
} from 'chart.js'

Chart.register(
  Tooltip,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Legend,
)

var isDollarSignNeeded = false

export default {
  name: 'Chart',
  props: {
    chartData: {
      type: Object,
    },
    charts: {
      type: Array,
      default: () => [],
    },
    isDollarSignNeeded: {
      type: Boolean,
    },
  },
  mounted() {
    const ctx = document.getElementById(this.chartData.name)
    this.config.data = this.chartData.data

    /*Chart.defaults.global.defaultFontFamily = 'Poppins-Light'*/
    /*Chart.defaults.global.defaultFontColor = '#000'*/
    /*Chart.defaults.global.defaultFontStyle = 'bold'*/

    var chart = new Chart(ctx, this.config)

    /*chart.canvas.parentNode.style.height = '600px';*/

    const chartWrapper = document.getElementById(`${this.chartData.name}ChartWrapper`)

    isDollarSignNeeded = this.isDollarSignNeeded
  },
  updated() {
    isDollarSignNeeded = this.isDollarSignNeeded
  },
  data() {
    return {
      config: {
        type: 'line',
        options: {
          plugins: {
            tooltip: {
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || ''
                  if (label) {
                    label += ': '
                  }

                  if (!isDollarSignNeeded) {
                    return `${context.parsed.y}`
                  }

                  if (context.parsed.y !== null) {
                    label += new Intl.NumberFormat('en-US', {
                      style: 'currency',
                      currency: 'USD',
                    }).format(context.parsed.y)
                  }
                  return label
                },
              },
            },
          },
          responsive: true,
          stacked: false,
          interaction: {
            mode: 'index',
            interset: false,
          },
          scales: {
            x: {
              type: 'category',
            },
            y: {
              type: 'linear',
              display: true,
              position: 'left',
              ticks: {
                callback: function(value, index, ticks) {
                  if (!isDollarSignNeeded) {
                    return value
                  }
                  return '$' + value
                },
              },
            },
          },
        },
      },
    }
  },
  watch: {
    isDollarSignNeeded: function(newValue) {
      isDollarSignNeeded = newValue
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.chart {
  &__wrapper {
    border: 1px solid $soft-gray;
    display: inline-block;
    width: 100%;
    padding: 1em;
  }

  &__subtitle {
    font-style: italic;
  }

  &__title {
    margin-bottom: 0;
    color: $black;
  }

  &__canvas_wrapper {
    position: relative;
  }
}
</style>
